import z from "zod";

const colorRegex = /^#([0-9a-f]{6}|[0-9a-f]{8})$/i;

export const QuillDeltaSegmentAttributesSchema = z.object({
  size: z.enum(["small", "large", "huge"]).optional(),
  background: z.string().regex(colorRegex).optional(),
  color: z.string().regex(colorRegex).optional(),
  bold: z.literal(true).optional(),
  italic: z.literal(true).optional(),
  underline: z.literal(true).optional(),
  strike: z.literal(true).optional(),
  font: z.enum(["monospace", "serif"]).optional(),
  link: z.string().optional(),
});

export const QuillDeltaLineAttributesSchema = z.object({
  align: z.enum(["center", "right", "justify"]).optional(),
  header: z.number().int().min(1).max(3).optional(),
  indent: z.number().int().min(1).max(7).optional(),
  list: z.enum(["bullet", "ordered"]).optional(),
  blockquote: z.literal(true).optional(),
});

export const QuillDeltaAttributesSchema =
  QuillDeltaSegmentAttributesSchema.extend(
    QuillDeltaLineAttributesSchema.shape
  );

export const QuillDeltaInsertSchema = z.union([
  z.string(),
  z.object({
    divider: z.literal(true),
  }),
]);

export const QuillDeltaOpSchema = z.object({
  insert: QuillDeltaInsertSchema,
  attributes: QuillDeltaAttributesSchema.optional(),
});

export const QuillDeltaSchema = z.object({
  ops: QuillDeltaOpSchema.array(),
});
